module.exports = __webpack_public_path__ + "img/wz-3-6.6f3c755f.jpg";